import { useFacilityConfig } from 'apis/getFacilityConfig';
import PageLoading from 'components/PageLoading';
import React, { createContext, ReactNode } from 'react';
import { useParams } from 'react-router-dom';


// Define the context type
type IResponseType = {
    config:{
        [key: string]: any
    }
}

// Define the props for the provider
type IProviderProps ={
    slug: string;
    children: ReactNode;
}

// Create the context with an initial value of null
const ModuleConfigContext = createContext<IResponseType>({} as IResponseType);

// Provider component
const ModuleConfigProvider: React.FC<IProviderProps> = ({ slug, children }) => {
    const { project_id } = useParams<{ project_id?: string}>();

    const {data: projectData, isFetching: isProjectFetching} = useFacilityConfig({project_id, slug, config: { cacheTime: 1000 * 60 * 60 }});

    return (
        <ModuleConfigContext.Provider value={projectData ?? {} as IResponseType}>
            {/* Render children components */}
            {!isProjectFetching && children}
            {/* If fetching, you can render a loading state here if needed */}
            {isProjectFetching && <PageLoading />}
        </ModuleConfigContext.Provider>
    );
}

// Optional: custom hook for consuming the context
export { ModuleConfigProvider };
export default ModuleConfigContext;